import firebaseConfig from '../firebase';

export function safeAvatarUrl(input?: string | null): string | undefined {
  const url = String(input || '').trim();
  if (!url) return undefined;

  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('//')) return `https:${url}`;
  if (url.startsWith('/')) return url;

  // gs://bucket/path
  if (url.startsWith('gs://')) {
    const rest = url.slice('gs://'.length);
    const firstSlash = rest.indexOf('/');
    if (firstSlash > 0) {
      const bucket = rest.slice(0, firstSlash);
      const objectPath = rest.slice(firstSlash + 1);
      const encodedPath = encodeURIComponent(objectPath);
      return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodedPath}?alt=media`;
    }
  }

  // bucket/path
  if (firebaseConfig?.storageBucket && /^[^/]+\/.+/.test(url)) {
    const bucket = firebaseConfig.storageBucket;
    const encodedPath = encodeURIComponent(url);
    return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodedPath}?alt=media`;
  }

  return url;
}
